<template>
  <div class="user-list-wrap">
    <template-search-list :listApi="listApi"
                          :buttonOption="buttonOption"
                          :defaultSortBy="defaultSortBy"
                          :reload="reload"
                          :selected="selected"
                          @select="setSelected"
                          @searchFilter="getSearchFilter"
                          @showDetail="showDetail">
      <ui-button :color="'darkgreen'"
                 @click="toggleChange">
        <i class="xi-renew"></i> 계정 변경
      </ui-button>
      <ui-button :color="'green'"
                 @click="toggleInsert">
        <i class="xi-plus"></i> 계정 등록
      </ui-button>

      <ui-button :color="'purple'"
                 @click="toggleExcel(true)">
        <i class="xi-view-list"></i> 엑셀 다운로드
      </ui-button>
    </template-search-list>

    <template-insert :show="show.change"
                     :metaApi="changeMetaApi"
                     :insertApi="changeApi"
                     :resultMsg="'아이디 변경이 완료되었습니다.'"
                     @reload="reloadList"
                     @saved="showDetail"
                     @close="toggleChange">
      <h4 class="title">계정 변경</h4>
    </template-insert>

    <template-insert :show="show.insert"
                     :metaApi="insertMetaApi"
                     :insertApi="insertApi"
                     @reload="reloadList"
                     @saved="showDetail"
                     @close="toggleInsert">
      <h4 class="title">계정 등록</h4>
    </template-insert>

    <template-detail :infoApi="infoApi"
                     :editApi="editApi"
                     :apiParam="apiParam"
                     @button="button"
                     @reload="reloadList"
                     @close="setSelected">
    </template-detail>

    <excel-column-select :excelDownload="excelDownload"
                         :metaApi="excelListMetaApi"
                         :listApi="listApi"
                         :searchFilter="searchFilter"
                         @export="excelExport"
                         @close="toggleExcel(false)"/>
  </div>
</template>

<script>

import {
  getUserList,
  getUserInfo,
  updateUser,
  insertUser,
  getUserInsertMeta,
  getUserExcelMeta,
  getChangeInsertMeta, changeUser
} from '@/api/user'

import TemplateSearchList from '@/components/_template/SearchList'
import TemplateDetail from '@/components/_template/Detail'
import TemplateInsert from '@/components/_template/Insert'
import UiButton from '@/components/_ui/UiButton'

import Excel from '@/utils/excel-export'
import ExcelColumnSelect from '@/components/_template/ExcelColumnSelect'
import { EventBus } from '@/utils/event-bus'
import { STORAGE_ITEM } from '@/utils/constants'

export default {
  name: 'UserList',
  components: {
    ExcelColumnSelect,
    TemplateSearchList,
    TemplateDetail,
    TemplateInsert,
    UiButton
  },
  methods: {
    showDetail (data) {
      this.apiParam = { userNum: data.userNum, userId: data.userId }
    },
    reloadList () {
      this.reload++
    },
    toggleInsert (value = null) {
      this.apiParam = null
      if (value !== null) {
        this.show.insert = !this.show.insert
      } else {
        this.show.insert = value
      }
    },
    toggleChange (value = null) {
      this.apiParam = null
      if (value !== null) {
        this.show.change = !this.show.change
      } else {
        this.show.change = value
      }
    },
    toggleExcel (value = false) {
      this.excelDownload = value
    },
    excelExport (col, data, selectCol) {
      const fileName = 'eagle_user'
      const excel = new Excel()
      EventBus.$emit('onLoading', true)
      excel.setExcelData('user', col, data || [], selectCol, {})
        .then(result => {
          excel.download(fileName)
          this.excelDownload = false
          EventBus.$emit('onLoading', false)
        }).catch(e => {
          EventBus.$emit('onLoading', false)
        })
    },
    getSearchFilter (value) {
      this.searchFilter = value
    },
    button (value, data) {
      const nameMap = {
        userBeusPlan: 'PlanBeus',
        userBaPlan: 'PlanBa',
        userBeusApply: 'ServiceBeusApply',
        userBaApply: 'ServiceBaApply',
        userBaDomain: 'ServiceBaDomain',
        userBeusCredit: 'CreditBeus',
        userBaCredit: 'CreditBa',
        jamCharge: 'PaymentJam',
        baJamUse: 'PaymentBa',
        beusJamUse: 'PaymentBeus'
      }
      if (data) {
        this.apiParam = data
      }
      localStorage.setItem(STORAGE_ITEM.searchData, JSON.stringify(this.apiParam))
      const route = this.$router.resolve({ name: nameMap[value], params: this.apiParam })
      window.open(route.href, '_blank')
    },
    setSelected (row) {
      this.selected = row
    },
  },
  data () {
    return {
      reload: 0,
      selected: null,

      infoApi: getUserInfo,
      editApi: updateUser,
      insertApi: insertUser,
      insertMetaApi: getUserInsertMeta,
      changeApi: changeUser,
      changeMetaApi: getChangeInsertMeta,
      apiParam: null,
      
      listApi: getUserList,
      excelListMetaApi: getUserExcelMeta,
      buttonOption: [
        {
          action: 'showDetail',
          columnText: '자세히',
          buttonText: '<i class="xi-arrow-right"></i>'
        }
      ],
      defaultSortBy: '-regDate',

      show: {
        insert: false,
        change: false
      },
      excelDownload: false,
      searchFilter: {}
    }
  }
}
</script>

<style lang="scss" scoped>
.user-list-wrap {
}
</style>
